import { EquipeAvisoView } from "./view-equipe-aviso";
import type { EquipeAvisoProps } from "./types-equipe-aviso";

export function EquipeAviso(props: EquipeAvisoProps) {
  return <EquipeAvisoView {...props} />;
}

export type * from "./types-equipe-aviso";
